<div class="w-full flex flex-row items-center min-h-screen -mt-16 pt-16">
  <div id="notFound" class="w-full text-center font-cursive text-4xl sm:text-6xl md:text-7xl xl:text-8xl font-semibold mb-6">
    Page Not Found :(
  </div>
</div>
